// Default
import '../../custom/js/default';

////JS
//import '../../custom/js/indexOptimized';

////JS Components
//import '../../custom/js/pages/trendreports';

////CSS
//import '../../custom/scss/style.scss';
